import {tokens} from '@packages/utilities/styled';

export const BACKGROUND_COLOR = '--avatar-background-color';
export const BACKGROUND_COLOR_DISABLED = '--avatar-background-color-disabled';
export const TEXT_COLOR_DISABLED = '--avatar-text-color-disabled';

export const AVATAR_COLOR_STYLES = {
  default: {
    [BACKGROUND_COLOR]: tokens.colors.purpleBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.purpleBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  pending: {
    [BACKGROUND_COLOR]: tokens.colors.grayBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.grayBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarDefaultTextDisabled,
  },
  /**
   * Regular Colors
   */
  blue: {
    [BACKGROUND_COLOR]: tokens.colors.blueBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.blueBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  green: {
    [BACKGROUND_COLOR]: tokens.colors.greenBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.greenBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  orange: {
    [BACKGROUND_COLOR]: tokens.colors.orangeBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.orangeBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  pink: {
    [BACKGROUND_COLOR]: tokens.colors.pinkBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.pinkBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  purple: {
    [BACKGROUND_COLOR]: tokens.colors.purpleBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.purpleBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
  red: {
    [BACKGROUND_COLOR]: tokens.colors.redBackground,
    [BACKGROUND_COLOR_DISABLED]: tokens.colors.redBackgroundDisabled,
    [TEXT_COLOR_DISABLED]: tokens.colors.uiAvatarColoredTextDisabled,
  },
} as const;

export const PRESENCE_GRADIENT_ID = {
  BLUE: 'presenceGradientBlue',
  GREEN: 'presenceGradientGreen',
  ORANGE: 'presenceGradientOrange',
  PINK: 'presenceGradientPink',
  RED: 'presenceGradientRed',
  YELLOW: 'presenceGradientYellow',
} as const;

export const PRESENCE_OUTLINE_COLORS = {
  blue: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.BLUE})`,
  },
  green: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.GREEN})`,
  },
  orange: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.ORANGE})`,
  },
  pink: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.PINK})`,
  },
  red: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.RED})`,
  },
  yellow: {
    stroke: `url(#${PRESENCE_GRADIENT_ID.YELLOW})`,
  },
  primary: {
    stroke: tokens.colors.textPrimary,
  },
  innerLine: {
    stroke: tokens.colors.background1,
  },
};
